import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { CSSTransition } from "react-transition-group";

import styles from "./phoneme.module.css";
import * as phonemeActions from "../../redux/actions/phoneme";
import { srcPath } from "../../util/Path";
import {
  BALLOON_STAGE,
  BASKET_STAGE,
  CLOUD_STAGE,
} from "../../redux/reducers/stateIdentifiers";
import { State } from "../../redux/store";
import { useAudio } from "../../hooks/CustomHooks";
import Ribbon from "./Ribbon";
import { phonemeAudio } from "../../redux/actions/phoneme";

const IntroPage = () => {
  const dispatch = useDispatch();

  const { mainPhonics, firstClicked } = useSelector(
    (state: State) => state.phoneme
  );

  const [balloonShow, setBalloonShow] = useState(false);
  const [basketShow, setBasketShow] = useState(false);
  const [cloudShow, setCloudShow] = useState(false);
  const clickAudio = useAudio("phoneme/click.wav");

  const selectGame = (stage: string) => {
    dispatch(phonemeActions.openInstruction());

    setTimeout(() => {
      clickAudio();
      switch (stage) {
        case BALLOON_STAGE:
          dispatch(phonemeActions.startBalloon());
          break;
        case BASKET_STAGE:
          dispatch(phonemeActions.startBasket());
          break;
        case CLOUD_STAGE:
          dispatch(phonemeActions.startCloud());
          break;
      }
    }, 100);

    if (!firstClicked) {
      phonemeAudio.finish.play();
      phonemeAudio.cloud.play();
      dispatch(phonemeActions.firstClick());
    }
  };

  useEffect(() => {
    const balloonTimeout = setTimeout(() => setBalloonShow(true), 100);
    const basketTimeout = setTimeout(() => setBasketShow(true), 300);
    const cloudTimeout = setTimeout(() => setCloudShow(true), 500);

    return () => {
      clearTimeout(balloonTimeout);
      clearTimeout(basketTimeout);
      clearTimeout(cloudTimeout);
    };
  }, [setBalloonShow, setBasketShow, setCloudShow]);

  // useEffect(() => selectGame(BASKET_STAGE), []);

  const introItems = [
    {
      style: "introBalloon",
      icon: "balloon_icon",
      stage: BALLOON_STAGE,
      show: balloonShow,
    },
    {
      style: "introBasket",
      icon: "basket_icon",
      stage: BASKET_STAGE,
      show: basketShow,
    },
    {
      style: "introCloud",
      icon: "cloud_icon",
      stage: CLOUD_STAGE,
      show: cloudShow,
    },
  ];

  return (
    <>
      <div className={styles.introGroup}>
        {introItems.map((item, index) => (
          <CSSTransition
            key={index}
            in={item.show}
            mountOnEnter
            timeout={500}
            classNames={{
              enter: styles.introItemEnter,
              enterActive: styles.introItemEnterActive,
              enterDone: styles.introItemEnterDone,
            }}
          >
            <img
              className={classnames(
                "abs",
                "btn",
                styles.introItem,
                styles[item.style]
              )}
              src={srcPath(`phoneme/intro_icons/${item.icon}.png`)}
              alt=""
              onClick={() => selectGame(item.stage)}
            />
          </CSSTransition>
        ))}
      </div>
      <img
        className={styles.introIcon}
        src={srcPath(`phoneme/game_icons/icon_${mainPhonics}.png`)}
        alt=""
      />
      <Ribbon style={{ top: "200px" }} />
    </>
  );
};

export default IntroPage;
